var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vca-column',[_c('vca-dropdown',{attrs:{"taggable":true,"options":_vm.organizerList,"label":"","placeholder":_vm.$t('events.organizer.placeholder')},model:{value:(_vm.organizer_id),callback:function ($$v) {_vm.organizer_id=$$v},expression:"organizer_id"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }